const {
  getJourneyNameFromJourneyType,
} = require("./getJourneyNameFromJourneyType");
const { BUSINESS_MODELS, JOURNEY_TYPE } = require("../../constants");

function getTargetJourney(configuration, targetBusinessModel, currentJourney) {
  if (currentJourney === JOURNEY_TYPE.CASH) {
    return currentJourney;
  }

  const journey = getJourneyNameFromJourneyType(currentJourney);
  const config =
    targetBusinessModel === BUSINESS_MODELS.B2B
      ? configuration.app.solJourney.b2b
      : configuration.app.solJourney;

  if (config[journey]?.enabled) {
    return currentJourney;
  }

  return JOURNEY_TYPE.CASH;
}

module.exports = { getTargetJourney };
